import { render } from "./ThreeVerticalDot.vue?vue&type=template&id=34781603"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ThreeVerticalDot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34781603"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34781603', __exports__)) {
    api.reload('34781603', __exports__)
  }
  
  module.hot.accept("./ThreeVerticalDot.vue?vue&type=template&id=34781603", () => {
    api.rerender('34781603', render)
  })

}


export default __exports__